var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlayersTitle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 816.56 79.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#f9c245;stroke-miterlimit:10;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M49.94,14.53H32.76V66.65H17.93V14.53H.75V1.6H49.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M155.1,1.6V66.65H140.27V41H71.63V66.65H56.81V1.6H71.63V27.66h68.64V1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.48,53.72V66.65H168.9V1.6h41.73V14.53h-26.9V27.94h23.6V41.26h-23.6V53.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.28,47.39h14.83c0,4.16,4.15,7.37,9.25,7.37,4.81,0,8.5-2.17,8.5-6.42,0-2.55-1.42-4.91-7.18-6.8l-7.74-2.36c-14.35-3.87-17.09-12.65-17.09-18.79,0-11.71,10-19.64,22.94-19.64,12.47,0,22,7.46,22,20.11H271c0-3.87-2.36-7.17-7.46-7.17-4.63,0-7.65,2.83-7.65,6.42,0,1.32.38,4.25,6.42,5.94l6.8,2.08c9.25,2.83,18.69,7.65,18.69,19.45,0,14-12.08,19.92-24,19.92C249.91,67.5,240.28,59.38,240.28,47.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M340.86,14.53H323.67V66.65H308.85V14.53H291.67V1.6h49.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M365.47,43.8h-2.92V66.65H347.72V1.6h26.63c15.11,0,21.9,10.76,21.9,21.53,0,9.16-4.81,17.18-15.29,19.82l16.8,23.7H380.49Zm-2.92-11.7H372c6.51,0,9.35-4.25,9.35-8.59s-2.93-9-9-9h-9.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M449.41,53.72V66.65H406.83V1.6h41.73V14.53H421.65V27.94h23.61V41.26H421.65V53.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M497.34,51.55H474.49l-4.81,15.1H453.81L477.89,1.6H494l24,65.05H502.25Zm-4.15-12.84L485.82,16l-7.27,22.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M585.6,66.65l-4.25-37L567.19,59.19H555.86L541.7,29.74l-4.34,36.91h-15.2l8-65.05h12.37l19,40.69L580.22,1.6h12.65l7.93,65.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M654,53.72V66.65H611.46V1.6h41.73V14.53H626.28V27.94h23.61V41.26H626.28V53.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M730.41,43.8H680.27V66.65H665.45V1.6h73.83c15.11,0,21.91,10.76,21.91,21.53,0,9.16-4.82,17.18-15.3,19.82l16.81,23.7H745.42ZM680.27,32.1h56.65c6.52,0,9.35-4.25,9.35-8.59s-2.93-9-9-9h-57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M768.32,47.39h14.82c0,4.16,4.16,7.37,9.25,7.37,4.82,0,8.5-2.17,8.5-6.42,0-2.55-1.42-4.91-7.17-6.8L786,39.18c-14.35-3.87-17.09-12.65-17.09-18.79,0-11.71,10-19.64,23-19.64,12.46,0,22,7.46,22,20.11H799c0-3.87-2.36-7.17-7.46-7.17-4.62,0-7.64,2.83-7.64,6.42,0,1.32.37,4.25,6.42,5.94l6.8,2.08c9.25,2.83,18.69,7.65,18.69,19.45,0,14-12.09,19.92-24,19.92C778,67.5,768.32,59.38,768.32,47.39Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayersTitle);
export default __webpack_public_path__ + "static/media/players-title.c5b3970c09ca2bf3c7378f12272b80ce.svg";
export { ForwardRef as ReactComponent };